import axios from 'axios';
import GLOBAL from '@/assets/js/global.js'

//store
import store from "@/assets/js/store.js";

//ajxa_map
let ajax_url_map = GLOBAL.ajax_url_map;

//http.js
/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */

//qs.stringify()是将对象 序列化成URL的形式，以&进行拼接
//  let protocol = window.location.protocol; //协议
//  let host = window.location.host; //主机
//  axios.defaults.baseURL = protocol + "//" + host;
//axios.defaults.baseURL = 'http://127.0.0.1:8000/api/'
// axios.defaults.headers = {'Content-Type': 'application/json'}
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
var instance = axios.create();
instance.defaults.timeout = 1000 * 20;
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use( //响应拦截
    async config => {
        // 每次发送请求之前判断vuex中是否存在token
        // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        config.headers.Authorization = store.state.token;

        if (config.url != ajax_url_map.tips) {
            config.headers["issn"] = GLOBAL.issn;
        }


        if (config.url == ajax_url_map.invite) {
            config.headers["Link"] = GLOBAL.domain;
        }    
        return config;
    },
    error => {
        return Promise.error(error);
    })
// 响应拦截器
// 这里要做一件事情，如果后端返回的status有错误，则要反映出来，使用el-message,如果后端的error中没有定义message，则使用默认的message，否则使用后端定义的message。
// 这便是拦截器的作用，之后所有的信息只要写在后端就行了，省的前端也写来写去重复代码。
axios.interceptors.response.use(
    // response:{data,status,statusText,header,config}，根据官网文档：
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // 当然，也可以在response.data里面加入code，这可以与后端进行约定
    response => {
        // 这里将不是200的都视为失败了
        // 如果status是200，但是服务器response.data.code又返回了code404，说明响应成功了，但是找不到数据，与后端定义了404是找不到数据，这是自定义的
        if (response.status === 200) {
            if(response.data.code == 0 ){
                //speciel
                return Promise.resolve(response.data); //进行中
            }
            else if(response.data.code == 401){//未登录
                //localStorage.clear();
                localStorage.setItem('token', '');
                localStorage.setItem('account', '');
                localStorage.setItem('userinfo', '');
                store.commit("$_setLogin", 0);
                store.commit("$_setUserinfo", {});
                store.commit("$_setAccount", {});             
                return Promise.reject(response.data);
            }          
            else{//其他错误
                return Promise.reject(response.data);
            }
        } else {
            // 这里如果reject了，则不会跳到下面的error，而是被catch抓到
            return Promise.reject(response); //失败
        }
    },
    // 服务器状态码不是200的情况
    // 受到服务器返回的error后，要
    // AxiosError{
    //  message,name,code:"ERR_BAD_REQUEST",config,request,
    // response{data:(来自服务器返回的),config,status:状态码，statusText,headers,request,}
    // }
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。

                // 在这里，可以对error.message根据status进行自定义更改，不使用默认值。
                case 401:
                    break
                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    sessionStorage.clear()
                    break
                // 404请求不存在
                case 404:
                    break;
                // 其他错误，直接抛出错误提示
                case 500:
                    error.message = '服务器内部错误'
                    break
                default:
            }
            return Promise.reject(error);
        }
    }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const $get = (url, cb, params) => {
    //这里也算是过度封装了，本身axios.get就是一个promise，这里又用了一层promise，然后把response或者error发出去
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params,
        })
            .then(res => {
                cb && cb.success && cb.success(res);
                resolve(res);
            },
            rej => {
                //console.log(rej)
                cb && cb.error && cb.error(rej);
            })
            .catch(err => {
                // 在响应拦截器里出现的reject，会跑到这里来，然后因为这里reject了，又会被使用$get().then().catch()里的catch接收到
                //这里就决定了外面收到什么东西              
                reject(err)
            })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const $post = (url, cb, params) => {
    return new Promise((resolve, reject) => {
        axios.post(url, params
            ) //是将对象 序列化成URL的形式，以&进行拼接
            .then(res => {
                cb && cb.success && cb.success(res);
                resolve(res);
            },
            rej => {
                //console.log(rej)
                cb && cb.error && cb.error(rej);
            })
            .catch(err => {           
                reject(err)
            })
    });
}
//下面是vue3必须加的，vue2不需要，只需要暴露出去get，post方法就可以
export {
    $get,
    $post
}
// export default{
//     install:(app) => {
//         app.config.globalProperties['$get'] = $get;
//         app.config.globalProperties['$post'] = $post;
//         app.config.globalProperties['$axios'] = axios;
//     }
// }



// WEBPACK FOOTER //
// ./src/assets/js/axios.http.js